const EMAILS = {
  EVENTS_FEEDBACK: 'eventsfeedback@seismic.com',
  LEARN_FEEDBACK: 'learnfeedback@seismic.com',
  PRACTICE_FEEDBACK: 'practicefeedback@seismic.com',
  INSIGHTS_FEEDBACK: 'learninginsightsfeedback@seismic.com',
  ELEARNING_FEEDBACK: 'weave_elearning_feedback@seismic.com',
  GPT_LESSON_FEEDBACK: 'gptlessonfeedback@seismic.com',
  AI: {
    LESSON_GENERATION: 'ailessongenerator@seismic.com',
  },
};

export default EMAILS;
